import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Form } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

const ListHeader = ({
  onSearch,
  setQueryParams,
  queryParams,
  menu,
  title,
  create,
  renderButton,
  children,
  searchForm,
  onBeforeFilter,
  buttonTitle = 'Novo',
  showChildren = true,
  initialValues = {},
  ...rest
}) => {
  const [delayedSearch, setDelayedSearch] = useState(null);

  const handleSearchChange = (e) => {
    if (delayedSearch) {
      clearTimeout(delayedSearch);
    }

    const input = e.target;

    if (onSearch && e.target) {
      setDelayedSearch(setTimeout(() => onSearch(input.value), 600));
      return;
    }

    setDelayedSearch(
      setTimeout(
        () =>
          setQueryParams({
            ...queryParams,
            page: 1,
            filterText: input.value
          }),
        600
      )
    );
  };

  const openToCreate = (record = {}) => {
    create(record);
  };

  const handleOnSubmit = () => {
    searchForm.validateFields().then((values) => {
      if (onSearch) {
        setDelayedSearch(setTimeout(() => onSearch(values), 600));
        return;
      }

      const newValues = onBeforeFilter ? onBeforeFilter(values) : values;

      setDelayedSearch(
        setTimeout(
          () =>
            setQueryParams({
              ...queryParams,
              page: 1,
              ...newValues
            }),
          600
        )
      );
    });
  };

  return (
    <div>
      <div className="gx-page-heading gx-col">
        {title || menu ? (
          <div className="gx-page-heading-title">
            {menu && menu.icon && (
              <span className="ant-avatar ant-avatar-square ant-avatar-icon">
                <FontAwesomeIcon className="icon" icon={menu.icon} />
              </span>
            )}

            {title}
          </div>
        ) : null}
        <div className="gx-page-heading-search">
          <div className="gx-search-bar gx-lt-icon-search-bar-lg gx-module-search-bar gx-d-none gx-d-sm-block">
            <div className="gx-form-group">
              <input
                className="ant-input gx-border-0"
                type="search"
                placeholder="Pesquisar..."
                onChange={handleSearchChange}
              />
              <span className="gx-search-icon gx-pointer">
                <i className="icon icon-search" />
              </span>
            </div>
          </div>
        </div>
        <div className="gx-page-heading-extra">
          {renderButton ? (
            renderButton()
          ) : (
            <div className="gx-page-heading-extra-button">
              <Button
                type="primary"
                onClick={() => openToCreate(initialValues)}
              >
                <PlusOutlined />
                {buttonTitle}
              </Button>
            </div>
          )}
        </div>
      </div>
      {showChildren && children ? (
        <div className="gx-d-flex gx-justify-content-end gx-page-heading-extra">
          {children}
        </div>
      ) : null}
    </div>
  );
};

export default ListHeader;
